//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import LogDetailsList from "./LogDetailsList";
export default {
  components: {
    LogDetailsList: LogDetailsList
  },
  data: function data() {
    return {
      tabKeys: "4",
      projectCode: ''
    };
  },
  created: function created() {
    if (window.localStorage.getItem('projectCode')) {
      this.projectCode = window.localStorage.getItem('projectCode');
    }

    this.tabKeys = "4";
  },
  computed: {},
  methods: {}
};